(function () {
  'use strict';

  var SKIN_QUIZ_STORAGE_KEY = 'dearme_skin_quiz_results';

  function readQuizResults() {
    try {
      var raw = localStorage.getItem(SKIN_QUIZ_STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearQuizResults() {
    try {
      localStorage.removeItem(SKIN_QUIZ_STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function trackEvent(name, payload) {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish('skin_quiz_' + name, payload || {});
      } catch (e) {
        /* ignore */
      }
    }
  }

  function animateCounter(el, target, duration) {
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(start + (target - start) * eased);
      el.textContent = value + '%';
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  function initResults(root) {
    if (!root || root.dataset.skinQuizResultsInit === 'true') return;
    root.dataset.skinQuizResultsInit = 'true';

    var emptyScreen = root.querySelector('[data-quiz-results-empty]');
    var loadedScreen = root.querySelector('[data-quiz-results-loaded]');
    var resultPercent = root.querySelector('[data-quiz-result-percent]');
    var resultCopy = root.querySelector('[data-quiz-result-copy]');
    var retakeLink = root.querySelector('[data-quiz-retake-link]');
    var stored = readQuizResults();

    function showEmpty() {
      if (emptyScreen) emptyScreen.hidden = false;
      if (loadedScreen) loadedScreen.hidden = true;
    }

    function showLoaded(resultMeta) {
      if (emptyScreen) emptyScreen.hidden = true;
      if (loadedScreen) loadedScreen.hidden = false;

      if (resultCopy && resultMeta.copy) {
        resultCopy.textContent = resultMeta.copy;
      }

      if (resultPercent && typeof resultMeta.percent === 'number') {
        animateCounter(resultPercent, resultMeta.percent, 1400);
      }

      trackEvent('skin_quiz_result', {
        percent: resultMeta.percent,
        raw_score: resultMeta.rawScore
      });

      trackEvent('skin_quiz_lead_submit', {});
    }

    if (!stored || !stored.resultMeta) {
      showEmpty();
      return;
    }

    showLoaded(stored.resultMeta);

    if (retakeLink) {
      retakeLink.addEventListener('click', function () {
        clearQuizResults();
        trackEvent('skin_quiz_retake', {});
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-skin-quiz-results]').forEach(initResults);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var results = event.target.querySelector('[data-skin-quiz-results]');
    if (results) initResults(results);
  });
})();
